import Vue from 'vue'

export const tooltipF = function(el, binding) { 
        if (binding.value === binding.oldValue) {
             return
        }
        if(binding.value == 'disable') {
            $(el).tooltip(binding.value);
        }
        else {
            $(el).tooltip('dispose');
            $(el).tooltip({
                title: binding.value,
                placement: binding.arg,
                trigger: 'hover'
            });
        }
    }

Vue.directive('tooltip', tooltipF);



//////////////////
// WEBPACK FOOTER
// ./static/js/tooltip/ToolTipDirective.js
// module id = null
// module chunks = 